import { createFileRoute } from '@tanstack/react-router'
import { Settings } from '../screens/Settings'
import { RoleGuard } from '../components/RoleGuard'

function SettingsRoute() {
  return (
    <RoleGuard>
      <Settings />
    </RoleGuard>
  )
}

export const Route = createFileRoute('/settings')({
  component: SettingsRoute,
})
